function setMaxHeight(selectors) {
    selectors.forEach(selector => {
        let elements = $(selector);
        if (elements.length === 0) return;

        elements.css('height', 'auto');
        let maxHeight = 0;

        elements.each(function () {
            maxHeight = Math.max(maxHeight, $(this).height());
        });

        elements.height(maxHeight);
    });
}

function casinoCompare() {
    const selectors = [
        '.js-casino-compare-top',
        '.js-casino-compare-license',
        '.js-casino-compare-bonus',
        '.js-casino-compare-deposit',
        '.js-casino-compare-payments',
        '.js-casino-compare-buttons'
    ];
    setMaxHeight(selectors);
}

(function ($) {
    $('.js-casino-compare-item').on('click', makeRefHandler());
    $('.js-casino-compare-logo').on('click', makeRefHandler());
    casinoCompare();
})(jQuery);
jQuery(window).on('resize load', function () {
    casinoCompare();
});
